import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    if (title) {
      document.title = `${title}`;
    } else {
      document.title = `Keliro | Social Gaming Entertainment`;
    }
  }, [title]);
};
